import React from 'react'
import Text24px from '../../../common/text/Text24px';

function RoomPreferencesMobile() {
  return (
    <div style={{ textAlign: 'center' }} className='w-[100%] h-[100%] flex items-center justify-center '>
      <Text24px>Please use a desktop screen or tablet for viewing this page</Text24px>
    </div>
  )
}

export default RoomPreferencesMobile;
